module.exports = __webpack_public_path__ + "static/logo-white@3x-beab9a41b9fe304647fc1a3d9b7f3580.png";